import { motion, AnimatePresence } from "framer-motion";
import { personalInfo } from "../lib/ui";

const Loader = ({ isLoading }) => {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className="fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-app-bg"
        >
          {/* Dot mesh background on loader */}
          <div className="absolute inset-0 bg-mesh opacity-50" />

          {/* Glow orbs */}
          <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-app-accent/10 rounded-full blur-[100px] animate-orb-pulse" />
          <div className="absolute bottom-1/3 right-1/3 w-64 h-64 bg-app-secondary/10 rounded-full blur-[80px] animate-orb-pulse" />

          <div className="relative flex flex-col items-center gap-8 z-10">
            {/* Animated logo mark */}
            <div className="relative w-20 h-20">
              {/* Outer spinning ring */}
              <motion.div
                animate={{ rotate: 360 }}
                transition={{ duration: 3, repeat: Infinity, ease: "linear" }}
                className="absolute inset-0 rounded-full border-2 border-transparent"
                style={{
                  background:
                    "linear-gradient(#020211, #020211) padding-box, linear-gradient(135deg, #3fa9f5, #a78bfa) border-box",
                }}
              />
              {/* Inner spinning ring – opposite direction */}
              <motion.div
                animate={{ rotate: -360 }}
                transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                className="absolute inset-2 rounded-full border-2 border-transparent"
                style={{
                  background:
                    "linear-gradient(#020211, #020211) padding-box, linear-gradient(135deg, #a78bfa, #3fa9f5) border-box",
                }}
              />
              {/* Core pulse */}
              <motion.div
                animate={{ scale: [1, 1.15, 1], opacity: [0.4, 1, 0.4] }}
                transition={{ duration: 1.8, repeat: Infinity, ease: "easeInOut" }}
                className="absolute inset-5 rounded-full"
                style={{
                  background: "linear-gradient(135deg, #3fa9f5, #a78bfa)",
                }}
              />
            </div>

            {/* Name */}
            <div className="text-center">
              <motion.p
                initial={{ opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2, duration: 0.5 }}
                className="font-display text-lg font-semibold text-app-text"
              >
                {personalInfo.fullName}
              </motion.p>
              <motion.div
                initial={{ scaleX: 0 }}
                animate={{ scaleX: 1 }}
                transition={{ delay: 0.4, duration: 0.6, ease: "easeOut" }}
                className="h-0.5 mt-2 rounded-full"
                style={{
                  background: "linear-gradient(135deg, #06b6d4, #a78bfa)",
                }}
              />
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loader;
